import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import AdmissionApplication from "./pages/AdmissionApplication";
import EngineersForms from "./pages/EngineersForms";
import ChangePassword from "./pages/ChangePassword";
import AllUsers from "./pages/AllUsers";
import AllRequests from "./pages/AllRequests";
import PrivateRoute from "./routes/PrivateRoute";
import FeePaymentForm from "./pages/FeePaymentForm";
import LeaveApplicationForm from "./pages/LeaveApplicationForm";
import EventRegistrationForm from "./pages/EventRegistrationForm";
import LibraryMembershipForm from "./pages/LibraryMembershipForm";
import HostelAccommodationForm from "./pages/HostelAccommodationForm";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />

          <Route element={<PrivateRoute />}>
            <Route path="home" element={<Home />} />
            <Route
              path="admission-application"
              element={<AdmissionApplication />}
            />
            <Route path="fee-payment-form" element={<FeePaymentForm />} />
            <Route path="leave-application-form" element={<LeaveApplicationForm />} />
            <Route path="event-registration-form" element={<EventRegistrationForm />} />
            <Route path="library-membership-form" element={<LibraryMembershipForm />} />
            <Route path="hostel-accommodation-form" element={<HostelAccommodationForm />} />

            <Route path="engineers-forms" element={<EngineersForms />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="all-users" element={<AllUsers />} />
            <Route path="all-requests" element={<AllRequests />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
